// Create new checkbox list:
// var checkbox_list = $(element).checkbox_list();
$(function () {
    var instances = {};

    $.fn.checkbox_list = function (action = null, value = null) {
        var instance;
        if (action === null) {
            instance = Object.assign({}, CheckboxList)
            instance.constructor(this);
            instances[instance.uuid] = instance;
            return this;
        } else {
            instance = instances[this.attr('data-uuid')];
            if (action === 'value') {
                if (value !== null) {
                    instance.updateValue(value);
                }
                return instance.value;
            }

            if (action === 'onUpdate' && typeof value === 'function' && instance) {
                instance.onUpdate(value);
            }
        }
    };

    var CheckboxList  = {
        el: null,
        listeners: [],
        uuid: '',
        items: null,
        value: [],
        type: null,
        checkbox: false,
        constructor: function (el) {
            this.el = el;
            this.uuid = Math.random().toString(36).slice(2);
            this.el.attr('data-uuid', this.uuid);
            this.items = el.find('.checkbox-list__item');
            if (this.items.length == 0) {
                this.checkbox = true;
                this.items = el.find('input[data-value]');
            }
            this.value = [];
            this.type = el.attr('data-type-checkbox');
            this.init();
        },
        init: function () {
            this.items.on('click', e => {
                var item = $(e.target);
                if (this.checkbox) {
                    if (item[0].checked) {
                        this.push(item.attr('data-value'));
                    } else {
                        this.pop(item.attr('data-value'));
                    }
                } else {
                    item.toggleClass('checkbox-list__item_checked');
                    if (item.hasClass('checkbox-list__item_checked')) {
                        this.push(item.attr('data-value'));
                    } else {
                        this.pop(item.attr('data-value'));
                    }
                }
            });
        },
        push: function (value) {
            if (this.value.indexOf(value) === -1) {
                this.value.push(value);
                this.runListeners();
            }
        },
        pop: function (value) {
            var index = this.value.indexOf(value);
            if (index !== -1) {
                this.value.splice(index, 1);
                this.runListeners();
            }
        },
        onUpdate: function (closure) {
            this.listeners.push(closure);
        },
        runListeners: function () {
            this.listeners.forEach(closure => {
                closure(this);
            });
        }
    }
});
